import { useState, useCallback } from 'react';
import { OperationMS } from '../types';
import { dechiffrerPlis } from '../services/operationMsService';
import { isPlisOuverts } from '../domain/analyse/accessAnalyse';
import { getDechiffrageInfo, DechiffrageInfo } from '../domain/analyse/historique';

// Pilote l'ouverture des plis (dechiffrage). Etat initial derive de l'operation (statut +
// historique), puis bascule a l'appel. Refetch apres succes (plus de window.location.reload).
export const useAnalyseDechiffrage = (operation: OperationMS, refetch: () => void) => {
  const [plisOuverts, setPlisOuverts] = useState<boolean>(isPlisOuverts(operation));
  const [info, setInfo] = useState<DechiffrageInfo>(getDechiffrageInfo(operation.historique));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const dechiffrer = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await dechiffrerPlis(operation.id);
      if (res.data) {
        setInfo({ date: res.data.created_at ?? null, operateur: res.data.operateur ?? null });
      }
      refetch();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Erreur lors du déchiffrage des plis');
    } finally {
      // Le legacy ouvre les sections d'analyse meme en cas d'echec (filet d'affichage).
      setPlisOuverts(true);
      setLoading(false);
    }
  }, [operation.id, refetch]);

  return { plisOuverts, info, loading, error, dechiffrer };
};
